import { z } from "zod";
import { roleSchema } from "./common";

export const staffSchema = z.object({
  id: z.string(),
  email: z.string(),
  role: roleSchema,
  totp_enabled: z.boolean(),
  created_at: z.string(),
});
export type Staff = z.infer<typeof staffSchema>;

export const authTokenResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number().int().positive(),
  staff: staffSchema,
});
export type AuthTokenResponse = z.infer<typeof authTokenResponseSchema>;

export const sessionSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  last_used_at: z.string(),
  ip_hash: z.string().nullable(),
  user_agent: z.string().nullable(),
  current: z.boolean(),
});
export type Session = z.infer<typeof sessionSchema>;

export const sessionsResponseSchema = z.object({
  items: z.array(sessionSchema),
});
export type SessionsResponse = z.infer<typeof sessionsResponseSchema>;
